import { IApplicationState } from '../../../../../../../types/types';
import { getChatGroups } from './getChatGroups';

export const getUnreadChatsCount = (state: IApplicationState) => {
    let chatBoards = getChatGroups(state);
    return chatBoards?.reduce((sum, item) => sum + item.newUserChatCount, 0) || 0;
}
